import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HeatRank from "./components/HeatRank";
import Nominations from "./components/Nominations";
import Dynamics from "./components/Dynamics";
import CoverGallery from "./components/CoverGallery";
import Poll from "./components/Poll";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-[#f6f0e6] text-[#18130e]">
      <Navbar />
      <main>
        <Hero />
        <HeatRank />
        <Nominations />
        <Dynamics />
        <CoverGallery />
        <Poll />
      </main>
      <Footer />
    </div>
  );
}